import React from 'react';
import { CopyToClipboard } from '@/components/common/copyToClipboard';
import { copyToClipboard } from '@/utils';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export default function PromotionalLinkCopy({ utmLink }: { utmLink: string }) {
  const { t } = useTranslation();
  return (
    <div
      className={`inline-flex gap-[6px] h-[22px] items-center rounded-[8px] w-fit mx-2 ${utmLink ? 'bg-[#EFF6FF] outline outline-[#BEDBFF] px-2' : ''}`}
    >
      <div
        className={`justify-center text-sm font-[600] leading-snug ${utmLink ? 'text-[#155DFC]' : 'text-[#1C2024]'}`}
      >
        {utmLink ? utmLink : t('ModalPromotionalLinkEducation.promotionalLink')}
      </div>
      {utmLink && (
        <CopyToClipboard
          onClick={() => {
            copyToClipboard(utmLink);
            toast.success(
              t('brandResources.promotionalLinkCopied', {
                defaultValue: 'Promotional link copied.'
              })
            );
          }}
        />
      )}
    </div>
  );
}
